import { useCallback } from 'react';
import { fetch as JSBFetch } from '@bridge/sharee';
import { useAtomValue } from 'jotai';
import { $AppIdConfig, $UserAgent } from '@lemon8/web-app-shared/atom';
import { useFetch } from './use-fetch';
import { HttpMethod } from './fetch';

export class SubmitEmailError extends Error {}

/**
 * @return 发送验证码的方法
 */
export default function useSubmitEmail(): (email: string) => Promise<void> {
  const { isInApp } = useAtomValue($UserAgent);
  const fetch = useFetch();

  const submitEmail = useCallback(
    async (email: string) => {
      if (isInApp) {
        const res = await (
          JSBFetch({
            url: '/api/__APP_VERSION__/email/send_code',
            headers: JSON.stringify({
              'Content-Type': 'application/json',
            }),
            method: 'post',
            isInnerDomain: false,
            data: {
              email,
            },
          }) as any
        ).catch(() => ({ error_code: 2 }));

        if (!res || res.error_code !== 0) {
          throw new SubmitEmailError();
        }
      } else {
        const { appId } = window.store.get($AppIdConfig);

        const res = await fetch('/api/200/email/send_code', {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            email,
          },
          overrideCommonQuery: {
            aid: appId,
          },
          method: HttpMethod.post,
        }).catch((e) => {
          console.error(e);
          return { error_code: 2 };
        });

        if (!res || res?.error_code !== 0) {
          throw new SubmitEmailError();
        }
      }
    },
    [isInApp],
  );

  return submitEmail;
}
